import { Button } from '../../atoms/Button';
import { Typography } from '../../molecules/Typography';

type ButtonProps = {
  label: string;
  topLabel?: string;
  onClick?: () => void;
  selected?: boolean;
};

interface iButtonGroupProps {
  buttons: ButtonProps[];
  className?: string;
  size?: 'small' | 'regular';
}

function ButtonGroup({
  buttons,
  className,
  size = 'regular',
}: iButtonGroupProps) {
  const buttonsClassNames = `
    bg-color-lightest
    text-mono-color-darkest
    font-bold

    rounded-none 
    border-hairline
    border-mono-color-medium

    group-first:rounded-l-[999px]
    group-last:rounded-r-[999px]

    px-[${size === 'small' ? '4' : '6'}]  
  `;

  const buttonItemClassNames = `
    group 
    flex 
    flex-col 
    text-center 
    w-full
  `;

  return (
    <div className={`flex ${className}`}>
      {buttons.map((button, index) => (
        <div className={buttonItemClassNames} key={index}>
          {button.topLabel && (
            <Typography size='mini' className='mb-1 text-mono-color-darker'>
              {button.topLabel}
            </Typography>
          )}
          <Button
            className={`${buttonsClassNames} ${
              button.selected
                ? `border-color-brand-primary bg-color-brand-primary text-button-color-primary-default`
                : ''
            }`}
            onClick={button.onClick}
            size={size}
            iconSize={size}
            full
          >
            {button.label}
          </Button>
        </div>
      ))}
    </div>
  );
}

export { ButtonGroup };
export type { iButtonGroupProps };

